module.exports = __webpack_public_path__ + "img/robert_hunt.86e29a75.png";